"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { Button } from "@rosette/web_components/src/ui/Button.js";
import Link from "next/link";
import { DISCORD_INVITE_URL } from "@rosette/ts/src/business/constants.js";
import { useOptionalUser } from "@/components/env/EnvContext.js";
import { RoyalBanner } from "@/components/social/banner/RoyalBanner.js";
import { Modal } from "@rosette/web_components/src/ui/Modal.js";
import { Card } from "@rosette/web_components/src/ui/Card.js";


export function Welcome() {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const user = useOptionalUser();

    const welcomeParam = searchParams?.get("welcome");
    const [welcome, setWelcome] = useState(welcomeParam ?? null);

    useEffect(() => {
        if (welcomeParam) {
            // Remove welcome query param.
            const nextSearchParams = new URLSearchParams(searchParams.toString());
            nextSearchParams.delete("welcome");
            router.replace(`${pathname}?${nextSearchParams}`);
        }
    }, [welcomeParam, searchParams, router, pathname]);

    if (!user)
        return (<></>);

    return (
        <Modal
            open={welcome === "setup"}
            onClose={() => setWelcome(null)}>

            <Card>
                <div className="w-full text-center text-3xl">
                    <RoyalBanner hideByLine={true} />
                    <h2 className="mt-6 mb-3 mx-0">
                        {`Welcome ${user.displayName}!`}
                    </h2>
                </div>

                <p>
                    We are excited to have you join our community of
                    Royal Game of Ur players! If you&apos;d like to meet
                    our other members, consider
                    {" "}
                    <Link href={DISCORD_INVITE_URL}>
                        joining our Discord server.
                    </Link>
                </p>
                <p>
                    I really hope you enjoy your games here!
                    <br />
                    ~ Padraig Lamont
                </p>

                <div className="block text-center w-full mt-4">
                    <Button
                        tone="accent"
                        size="lg"
                        onClick={() => setWelcome(null)}>

                        Get Started
                    </Button>
                </div>
            </Card>
        </Modal>
    );
}
